// extracted by mini-css-extract-plugin
module.exports = {"root":"CustomTip_root__d7EGO","inputWrap":"CustomTip_inputWrap__1ulwQ"};